import ApiResourceManager from '../ApiResourceManager';

export default class MarketingOverviewManager extends ApiResourceManager {
  getServiceProviderLevelStats = (params) =>
    this.request({
      method: 'GET',
      url: '/marketing/stats',
      params,
    });
}
